import useSWR from 'swr';
import { useLocale } from '@peloton/internationalize/locales';
import { IMMUTABLE } from '@content/client/revalidation';
import type { BundleTypeMap } from '../utils/fetchBasicsPackagesMap';
import fetchBasicsPackagesMap from '../utils/fetchBasicsPackagesMap';

const useBasicsPackagesMap = () => {
  const locale = useLocale();
  return useSWR<BundleTypeMap | undefined>(
    'basicsPackages',
    () => fetchBasicsPackagesMap(locale),
    {
      ...IMMUTABLE,
    },
  );
};

export default useBasicsPackagesMap;
